import React from "react";
import SettingsPage from "../../../components/List/SettingsList"

import { useTranslation } from "react-i18next";
const CollectionSettingsPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <SettingsPage
            title={t("common.collection")}
            fetchUrl="/itemApi/GetCollectionList"
            createOrUpdateUrl="itemApi/CreateOrUpdateCollection"
            deleteUrl="itemApi/DeleteCollection"

        />
    );
};

export default CollectionSettingsPage;
